import React from 'react';
import type { InternalMedicineData } from '../../hooks/useConsultationForm';
import DiabetesAssessment from './DiabetesAssessment';
import HypertensionAssessment from './HypertensionAssessment';
import DyslipidemiaSection from './DyslipidemiaSection';
import CardiovascularRisk from './CardiovascularRisk';
import MetabolicSyndrome from './MetabolicSyndrome';
import TreatmentPlan from './TreatmentPlan';
import SectionNumberBadge from '../SectionNumberBadge';

interface Props {
  internalMedicineData: InternalMedicineData;
  setInternalMedicineField: (section: keyof InternalMedicineData, field: string, value: any) => void;
  patientSex: 'male' | 'female' | null;
  patientAge: number | null;
  sectionNumber?: string;
}

const InternalMedicineSection: React.FC<Props> = ({
  internalMedicineData,
  setInternalMedicineField,
  patientSex,
  patientAge,
  sectionNumber,
}) => {
  return (
    <div className="row mb-4" data-section="medicina-interna">
      <div className="col-sm-12">
        <div className="card border-info">
          <div className="card-header text-white" style={{ backgroundColor: '#0d9488' }}>
            <h4 className="card-title mb-0">
              {sectionNumber && <SectionNumberBadge number={sectionNumber} inverse />}
              <i className="fa fa-stethoscope me-2"></i>
              Evaluación Medicina Interna
            </h4>
          </div>
          <div className="card-body">
            {patientSex && patientAge !== null && (
              <div className="alert alert-info py-2 mb-3 small">
                <i className="fa fa-info-circle me-1"></i>
                Paciente {patientSex === 'male' ? 'masculino' : 'femenino'} — {patientAge} años
              </div>
            )}

            <DiabetesAssessment
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
            />

            <HypertensionAssessment
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
            />

            <DyslipidemiaSection
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
            />

            <CardiovascularRisk
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
              patientSex={patientSex}
              patientAge={patientAge}
            />

            <MetabolicSyndrome
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
              patientSex={patientSex}
            />

            <TreatmentPlan
              internalMedicineData={internalMedicineData}
              setInternalMedicineField={setInternalMedicineField}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalMedicineSection;
